import i18n from 'i18next';
import { MeterReadingFromApi } from 'meterReading/types/charts';
import { LinkData } from 'meterReading/types/LinkData';
import { IMeterReadingsData } from 'rentalObject/types/rentalObjects';

export const getMeterLinksData = (meterReadingsData: IMeterReadingsData[], selectedObjectID: number): LinkData[] => {
    let getMeterLinksData: LinkData[] = [];

    if (meterReadingsData && meterReadingsData.length > 0) {
        getMeterLinksData = meterReadingsData.map(({ meter }) => {
            const { type, id } = meter;

            return {
                text: i18n.t('documents.meterReadings.' + type),
                path: `meter-reading/${selectedObjectID}/${type}--${id}`,
                typeWithId: `${type}__${id}`,
                type: type,
            };
        });
    }

    return getMeterLinksData;
};

export function getDashboardMeterLinksData(
    meterReadingsData: MeterReadingFromApi[],
    selectedObjectID: number | null,
): LinkData[] {
    const meterLinksData: LinkData[] = [];

    if (!meterLinksData.length || !selectedObjectID) {
        return meterLinksData;
    }

    // Using for loop to improve performance on large datasets
    for (let i = 0; i < meterReadingsData.length; i++) {
        const { meter } = meterReadingsData[i];
        const { type, id } = meter;

        meterLinksData.push({
            text: i18n.t('documents.meterReadings.' + type),
            path: `meter-reading/${selectedObjectID}/${type}--${id}`,
            typeWithId: `${type}__${id}`,
            type: type,
        });
    }

    return meterLinksData;
}
